const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/auth/reducers/auth.reducer.js